import React from "react";
import {Box, Typography} from "@mui/material";
import {FooterTabFragment, FooterTabFragmentProps, FooterTabFragmentState} from "../../shared/FooterTabFragment";
import {PathComponent} from "../../shared";
import {StyledBoxColumn} from "../../shared/StyledComponents";
import {CATEGORIES} from "./types";
import {LessonsGrid} from "../util/Components";
import {PAGE_FRAGMENT_LG_WIDTH, PD_LG, PD_XLG} from "../../shared/dimens";
import {LESSONS} from "./consts";

export type PracticeFragmentProps = FooterTabFragmentProps & {}

type PracticeFragmentState = FooterTabFragmentState & {}

export class PracticeFragment extends FooterTabFragment<PracticeFragmentProps, PracticeFragmentState> {

  static nestedPaths(): PathComponent[] {
    return [];
  }

  getTitle(): string {
    return "Practice";
  }

  renderContent(): React.ReactElement | null {
    return <Box style={{
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
      gap: PD_XLG,
      margin: "auto",
      maxWidth: PAGE_FRAGMENT_LG_WIDTH,
      width: "100%",
      padding: PD_LG,
    }}>
      {CATEGORIES.map(category => {
        const lessons = LESSONS
          .filter(lesson => lesson.categoryId === category.id);
        return <StyledBoxColumn>
          <Typography variant={"h5"}>{category.text}</Typography>
          <LessonsGrid path={this.props.path} lessons={lessons}/>
        </StyledBoxColumn>;
      })}
    </Box>;
  }
}
